<div class="content p-5">
  <p class="is-bold is-size-5 color-darkblue has-text-centered">
    Information
  </p>

  <div class="columns mb-0">
    <div class="column line-height-is-2 pb-0">
      <p>Sehr geehrter Kunde,</p>
      <p>
        bitte beachten Sie, dass es in Bayern, Rheinland-Pfalz, Thüringen und Saarland nur private
        Anbieter für Kampfmittelauskünfte gibt. Hierdurch kommt es, im Vergleich zu anderen
        Bundesländern, zu einem größeren Aufwand und zu Mehrkosten, die zwischen 2.500 € und 3.500 €
        liegen. Bei Kampfmittelauskünften aus den anderen Bundesländern fallen Kosten zwischen 100 € und
        800 € an. Möchten Sie die Kampfmittelauskunft bestellen?
      </p>
      <p class="mb-0">Ihr DocEstate-Team</p>
    </div>
  </div>

  <hr>

  <ng-container *ngIf="ProductUtils.shouldOpenProductValueDialog([kampfmProduct]) else defaultButtons">
    <app-product-value-form [products]="[kampfmProduct]" [hasPadding]="false" [property]="selectedProperty" (cancelModalEvent)="cancelModal()" (confirmModalEvent)="submitModal()"></app-product-value-form>
  </ng-container>

  <ng-template #defaultButtons>
    <div class="columns">
      <div class="column is-one-third">
        <a class="button back-button has-round-border" (click)="cancelModal()">
          <div class="columns is-align-items-center is-justify-content-center">
            <div class="column is-bold">
              <p class="mb-0">Abbrechen</p>
            </div>
          </div>
        </a>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third">
        <a class="button buy-button has-round-border" (click)="submitModal()">
          <div class="columns is-align-items-center is-justify-content-center">
            <div class="column is-bold">
              <p class="mb-0">Bestätigen</p>
            </div>
          </div>
        </a>
      </div>
    </div>
  </ng-template>

</div>
